import type { MarketingPopupFragmentResult } from "@/lib/sanity/sanity.types";
import type { VisualType } from "@/lib/types";

export type MarketingPopupData = NonNullable<
  MarketingPopupFragmentResult["global"]
>;

export interface MarketingPopupVariantProps {
  popup: MarketingPopupData;
  className?: string;
  /** Wired to the card's close button when rendered inside the modal. */
  onClose?: () => void;
  /** Fires before the CTA navigates, so the modal can record popup_click. */
  onCtaClick?: () => void;
}

/**
 * A pop-up may be text-and-CTA only, so every variant degrades without media.
 *
 * Cast: the pop-up fragment projects the shared `visualModuleFragment`, the
 * same selection VisualType is derived from — typegen just mints a separate
 * alias per query (same pattern as SimpleVisualBlock).
 */
export function popupVisual(popup: MarketingPopupData): VisualType | null {
  return popup.visual?.mediaSource
    ? (popup.visual as unknown as VisualType)
    : null;
}
